import { AppLangCode } from '@libs/types';
export const enFonts = {
    primaryRegular: 'Satoshi-regular',
    primary: 'Satoshi-medium',
    primaryMedium: 'Satoshi-medium',
    primaryBold: 'Satoshi-bold',
};
export const kaFonts = {
    primaryRegular: 'Helvetica-regular',
    primary: 'Helvetica-regular',
    primaryMedium: 'Helvetica-medium',
    primaryBold: 'Helvetica-bold',
};
export const cyrillicFonts = {
    primaryRegular: 'TT-Hoves-Pro-regular',
    primary: 'TT-Hoves-Pro-regular',
    primaryMedium: 'TT-Hoves-Pro-medium',
    primaryBold: 'TT-Hoves-Pro-bold',
};
export const fontsByLang = {
    [AppLangCode.KA]: kaFonts,
    [AppLangCode.RU]: cyrillicFonts,
    [AppLangCode.UA]: cyrillicFonts,
    [AppLangCode.EN]: enFonts,
};
export default enFonts;
//# sourceMappingURL=fonts.js.map